<template>
  <div class="header" :style="{height: messageInfo.title?'164px':'64px'}">
    <div class=" flex padding-lr-100 bg-white align-center justify-between height64">
      <img class="logo" src="../../../assets/images/logoText.png" alt @click="$router.push('/')">
      <div class="nav">
        <a href="/">主页</a>
        <a href="#playOrder">下单</a>
        <a href="#advantage">优势</a>
        <a href="#about">公司简介</a>
        <a href="#Service">联系我们</a>
        <a href="#ServiceArea">服务范围</a>
        <!-- <a href="#Mode">新老模式对比</a> -->
        <el-dropdown>
          <span class="el-dropdown-link point">
            用户下单，师傅加盟<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-popover placement="right" width="300" trigger="hover">
                <el-image :src="appImage"></el-image>
                <div slot="reference">师傅加盟接单，APP扫码下载</div>
              </el-popover>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-popover placement="right" width="300" trigger="hover" class="flex align-center justify-center">
                <el-image :src="xcxImage"></el-image>
                <div slot="reference">用户需求发布，小程序扫码下单</div>
              </el-popover>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!--      <a href="#">软件下载</a>-->
      </div>
      <div class="nav-actions flex justify-end">
        <div class="margin-right-30">
          <span class="el-dropdown-link point" @click="$router.push({name:'workbench'})">工作台</span>
        </div>
        <div class="margin-right-10">
          <span class="el-dropdown-link point" @click="toPublic">
            立即下单 <i class="el-icon-arrow-down el-icon-right"></i>
          </span>
        </div>
      </div>
      <div class="login" v-if="!$store.state.hasLogin">
        <div class="login-btn" @click="$router.push({name:'login'})">登录</div>
        <div class="register" @click="$router.push({name:'register'})">立即注册</div>
      </div>
      <div v-if="$store.state.hasLogin">
        <user></user>
      </div>
    </div>
    <div v-if="messageInfo.title" @click="toMessage"
      class="bg-message flex align-center  padding-lr-30 margin-lr-100 margin-tb-20 line-theme height60 ">
      <img src="../../../assets/images/dkw.png" alt="" class="block-26">
      <span class="text-theme margin-left-10">{{messageInfo.title}}</span>
    </div>
  </div>
</template>
<script>
  import user from '../../../components/user'

  export default {
    components: {
      user
    },
    data() {
      return {
        islogin: false,
        messageInfo: '',
        appImage: '',
        xcxImage: ''
      }
    },
    created() {
      this.islogin = this.$store.state.hasLogin
      this.getInfo()
      let vm = this
      if(this.$store.state.hasLogin){
        this.$request('62cfd88b56ba2', {}).then(res => {
          vm.messageInfo = res.data.data.least_system
        })
      }
      
      console.log(this.$store.state.hasLogin)
      console.log(this.$store.state.userInfo)
    },
    methods: {
      toMessage(){
        this.$router.push({
          name: 'message'
        })
      },
      getInfo() {
        this.$request('61cbbdb6af43a', {
          edition_number: '1'
        }).then(res => {
          this.appImage = res.data.data.edition.appDownload
          this.xcxImage = res.data.data.edition.wxDownload
        })
      },
      login() {
        this.$router.push({
          name: 'login'
        })
      },
      toPublic() {
        if (!global.userInfo) {
          return this.$router.push({
            name: 'login'
          })
        }
        this.$router.push({
          name: 'place'
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .bg-message {
    line-height: 60px;
    position: relative;
    background-color: rgb(254, 241, 236);
  }

  .header {
    width: 100%;
    background-color: #f5f7f9;
    min-width: 1200px;
    position: fixed;
    top: 0;

    .nav {
      display: flex;
      flex: 1;
      justify-content: center;

      a {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        //align-items: flex-end;
        color: #090B17;
        margin-right: 40px;
      }
    }

    .nav-actions {
      display: flex;
      align-items: center;
      margin-left: auto;
      margin-right: 0;
      padding: 0 30px;
      flex-shrink: 0;
    }

    .login {
      display: flex;
      align-items: center;
      cursor: pointer;

      .login-btn {
        width: 50px;
      }

      .register {
        width: 104px;
        height: 64px;
        text-align: center;
        background-color: #FB9E2F;
        font-size: 14px;
        color: #fff;
        line-height: 64px;
      }
    }

    .el-dropdown-link {
      color: #090B17;
    }

  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #FB9E2F;
    color: #FFFFFF;
  }
</style>
